/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

/* sarah moved in stock notification, future note: should write this using toggle rather than s/h but ran out of time. Fixed A.C. 15/9/23 */

document.addEventListener('variant:changed', function(event) {
  var variant = event.detail.variant; // Gives you access to the whole variant details
  var stockEl = document.querySelector("#stock-display");
  var outEl = document.querySelector("#out-stock-display");
  var preEl = document.querySelector("#preorder-display");
  var noteEl = document.querySelector(".ProductForm__PreorderNote");
  var avail = !!(variant && variant['available']);

  // Pre-order template can mix a genuine 0-stock pre-order variant with a real-stock variant
  // on the same product (e.g. Black back in stock, White still inbound). template_suffix alone
  // can't tell them apart, so use the per-variant quantity map emitted by main-product.liquid
  // (window.AVR_PREORDER_VARIANT_QTY) — only present on the pre-order template.
  var isPreorderVariant = false;
  if (variant && window.AVR_PREORDER_VARIANT_QTY) {
    var qty = window.AVR_PREORDER_VARIANT_QTY[String(variant.id)];
    isPreorderVariant = (typeof qty !== 'undefined') && qty <= 0;
  }

  // Button label: theme.js's _updateAddToCartButton already ran by the time this listener
  // fires and set the label from a fixed global — it has no concept of per-variant stock.
  // Correct it here for the actual selected variant.
  if (variant && avail && window.AVR_PREORDER_VARIANT_QTY) {
    var addToCartButton = document.querySelector('.ProductForm__AddToCart');
    if (addToCartButton) {
      var label = isPreorderVariant ? window.languages.productFormPreOrder : window.languages.productFormAddToCart;
      var labelSpan = addToCartButton.querySelector('span');
      if (labelSpan) {
        labelSpan.textContent = label;
      } else {
        addToCartButton.innerHTML = '<span>' + label + '</span>';
      }
    }
  }

  if (preEl) {
    if (isPreorderVariant && avail) {
      preEl.style.display = "block";
      if (stockEl) stockEl.style.display = "none";
      if (outEl) outEl.style.display = "none";
      if (noteEl) noteEl.style.display = "";
    } else if (avail) {
      preEl.style.display = "none";
      if (stockEl) stockEl.style.display = "block";
      if (outEl) outEl.style.display = "none";
      if (noteEl) noteEl.style.display = "none";
    } else {
      preEl.style.display = "none";
      if (stockEl) stockEl.style.display = "none";
      if (outEl) outEl.style.display = "block";
      if (noteEl) noteEl.style.display = "none";
    }
    return;
  }

  if (!stockEl || !outEl) return; // null-safe: some templates omit these
  if (avail) {
      stockEl.style.display = "block";
      outEl.style.display = "none";
  } else {
      stockEl.style.display = "none";
      outEl.style.display = "block";
  }
});


/* ===== Resolve iPad background attachment pixellation issue, for iPads post 2014 - A.C. 13/2/23 ===== */

// fix the pixellation issue with full-width images for iPad (how does this interact with AOS though?)
const platform = navigator?.userAgentData?.platform || navigator?.platform || 'unknown'
if (platform == "iPad") {
    const orientationLandscape = window.matchMedia("(orientation: landscape)")
    window.addEventListener('DOMContentLoaded', iPadImageFix)
    window.addEventListener('resize', iPadImageFix)
}

function iPadImageFix() {
    document.querySelectorAll('.ImageHero__ImageWrapper, .ImageHero__Image').forEach(el => {
        el.style.webkitBackgroundAttachment = "scroll"
        el.style.backgroundAttachment = "scroll"
        if (orientationLandscape.matches) {
            el.style.webkitBackgroundPosition = "150% auto"
            el.style.backgroundPosition = "150% auto"
        } else {
            el.style.webkitBackgroundPosition = "auto 150%"
            el.style.backgroundPosition = "auto 150%"
        }
    })
}


// Angus' script for resizing the 9000N GUI 13/9/23
window.addEventListener('load', function() {
    resizeGUI();
    window.addEventListener('resize', resizeGUI());
})

function resizeGUI() {
    if (window.innerWidth > 640 && document.title.includes('Audiolab 9000N Wireless Audio Streaming Player')) {
        document.querySelectorAll('section.Section')[8].querySelector('img').style.transform = "scale(0.7)";
    }
}
// End Angus' script for resizing the 9000N GUI 13/9/23
